import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';
import { getIn } from 'formik';

function TextInput(props) {
  const { field, form, label, ...restProps } = props;

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);
  const hasError = error !== undefined && touched;
  const isValid = !error && !!touched;

  const { name, onChange, onBlur, value } = field;
  return (
    <Form.Item
      validateStatus={hasError ? 'error' : undefined}
      hasFeedback={isValid}
      label={label}
      help={(hasError && <li>{error}</li>) || (isValid && '')}
    >
      <Input
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={label}
        {...restProps}
      />
    </Form.Item>
  );
}
TextInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string
};
export default TextInput;
